import './InputFormSkeleton.css';

const InputFormSkeleton = () => {
  return (
    <div className="skeleton-form">
      <div className="skeleton-form-group">
        <label className="skeleton-label"></label>
        <div className="skeleton-input"></div>
      </div>
      <div className="skeleton-form-group">
        <label className="skeleton-label"></label>
        <div className="skeleton-textarea"></div>
      </div>
      <div className="skeleton-form-group">
        <label className="skeleton-label"></label>
        <div className="skeleton-select"></div>
      </div>
      <div className="skeleton-form-group">
        <label className="skeleton-label"></label>
        <div className="skeleton-select"></div>
      </div>
      <div className="skeleton-form-actions">
        <div className="skeleton-button"></div>
        <div className="skeleton-button primary"></div>
      </div>
    </div>
  );
};

export default InputFormSkeleton;